import Banner from '../component/banner';
import Auctiondetails from '../component/Auctionsdetails';
import Livesession from '../component/Livesession';
import Featureheat from '../component/Featuredheat';
import '../component/Featuredheat.css';
import Chooseobs from '../component/Chooseobs';
import WeeklyBundle from '../component/WeeklyBundle';
import Commandcenter from '../component/Commandcenter';
import Exclusivebundles from '../component/Exclusivebundles';
import Everythingwin from '../component/Everythingwin';
import Footer from '../component/Footer';
import { navigateTo } from '../app/routes';
import './HomePage.css';

function HomePage() {
  return (
    <section className="home-page" id="home" aria-label="Home page">
      <Banner
        primaryCta={{ label: 'Start Bidding', onClick: () => navigateTo('/live-auctions') }}
        secondaryCta={{ label: 'Shop Buy Now', onClick: () => navigateTo('/shop') }}
      />
      <Auctiondetails />
      <Livesession />
      <Featureheat />
      <VisitorFlow />
      <WeeklyBundle />
      <Chooseobs />
      <Commandcenter />
      <Exclusivebundles />
      <Everythingwin />
      <Footer />
    </section>
  );
}

function VisitorFlow() {
  const steps = [
    {
      eyebrow: '01',
      title: 'Browse the floor',
      text: 'Start with live auctions or the fixed-price shop. Visitors can inspect lots, pricing, countdowns, inventory, and weekly-bundle eligibility before creating an account.',
      cta: { label: 'Open Auctions', href: '/live-auctions' },
    },
    {
      eyebrow: '02',
      title: 'Create collector access',
      text: 'Register once, then use the same account for watchlists, saved shipping, orders, bundle checkout, alerts, and consignment tracking.',
      cta: { label: 'Register', href: '/register' },
    },
    {
      eyebrow: '03',
      title: 'Verify bidder card',
      text: 'Bidding and fast checkout stay gated behind a saved card, so serious buyers can move quickly and unpaid wins can be controlled professionally.',
      cta: { label: 'Payment Setup', href: '/dashboard/payments' },
    },
    {
      eyebrow: '04',
      title: 'Bid, buy, or bundle',
      text: 'Win timed auctions, quick-pay shop items, or hold eligible purchases for Friday combined checkout with fixed MVP shipping.',
      cta: { label: 'Shop Now', href: '/shop' },
    },
  ];

  return (
    <section className="visitor-flow" aria-labelledby="visitor-flow-title">
      <div className="visitor-flow__head">
        <span>Visitor path</span>
        <h2 id="visitor-flow-title">From first look to first win</h2>
        <p>
          The public site now routes visitors into the real marketplace flow: inspect inventory, create access,
          verify once, then bid, buy, bundle, or track items from the dashboard.
        </p>
      </div>

      <div className="visitor-flow__grid">
        {steps.map((step) => (
          <article key={step.eyebrow}>
            <span>{step.eyebrow}</span>
            <h3>{step.title}</h3>
            <p>{step.text}</p>
            <a href={step.cta.href}>{step.cta.label}</a>
          </article>
        ))}
      </div>
    </section>
  );
}

export default HomePage;
